const DataExportStatus = {
  SCHEDULED: "scheduled",
  IN_PROGRESS: "in_progress",
  DONE: "done",
  FAILED: "failed",
};

export default DataExportStatus;
